import Feedback from "./views/Feedback.vue";
import FeedbackCard from "./components/FeedbackCard.vue";
import FeedbackDocument from "./components/FeedbackDocument.vue";

export default [
  {
    path: "/feedback",
    component: Feedback,
    children: [
      {
        path: "",
        redirect: "/feedback/feedback-card/:code/:docNo/:reference",
      },
      {
        path: "feedback-card/:code/:docNo/:reference",
        name: "FeedbackCard",
        component: FeedbackCard,
      },
      {
        path: "feedback-document/:code/:docNo/:reference",
        name: "FeedbackDocument",
        component: FeedbackDocument,
      },
    ],
  },
];
